import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-table-reservation',
  templateUrl: './table-reservation.component.html',
  styleUrls: ['./table-reservation.component.scss']
})
export class TableReservationComponent implements OnInit {

  iframeLoaded = false;

  iframeSrc: any;

  @ViewChild('iframe') iframe: ElementRef;

  constructor(
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    // tslint:disable-next-line:max-line-length
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl('https://foratable.com/reserve/restaurant/ee692e91f8abf533960e8d312116e344#/table');
    setTimeout(() => {
      this.iframe.nativeElement.addEventListener('load', () => {
        this.iframeLoaded = true;
      });
    }, 10);
  }

}
